"use client";

import { c as _c } from "react/compiler-runtime";
import { LazyMotion, domAnimation } from "framer-motion";
interface MotionProviderProps {
  children: React.ReactNode;
  /** Strict mode enforces 'm' component usage for tree-shaking (default: false to allow 'motion' components) */
  strict?: boolean;
}

/**
 * LazyMotion provider for optimized bundle size.
 *
 * Using domAnimation feature package reduces bundle from ~16KB to ~4.6KB.
 * This includes: animations, variants, exit animations, tap/hover/focus gestures.
 *
 * Note: Does NOT include pan/drag gestures or layout animations (use domMax for those).
 */
export function MotionProvider(t0) {
  const $ = _c(3);
  const {
    children,
    strict: t1
  } = t0;
  const strict = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== children || $[1] !== strict) {
    t2 = <LazyMotion features={domAnimation} strict={strict}>{children}</LazyMotion>;
    $[0] = children;
    $[1] = strict;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}